import React from "react";
import Proptypes from "prop-types";
import CtaButton from "../../Elements/CtaButtonElement";
import {
	ReviewsWrapper,
	TextContainer,
	ReviewsContainer,
	Heading,
	SubHeading,
	CtaWrapper,
} from "./style";

import RatingCard from "./Cards";

const ReviewsBanner = (props) => {
	const { header, description, cta, cards } = props;
	return (
		<ReviewsWrapper>
			<TextContainer>
				<Heading
					dangerouslySetInnerHTML={{
						__html: header,
					}}
				></Heading>
				<SubHeading
					dangerouslySetInnerHTML={{
						__html: description,
					}}
				></SubHeading>
				{cta && (
					<CtaWrapper>
						<CtaButton cta={cta} darkBg={true} />
					</CtaWrapper>
				)}
			</TextContainer>
			<ReviewsContainer>
				{cards.map((card, index) => {
					return <RatingCard key={index} {...card} />;
				})}
			</ReviewsContainer>
		</ReviewsWrapper>
	);
};

ReviewsBanner.propTypes = {
	header: Proptypes.string,
	description: Proptypes.string,
	cta: Proptypes.shape({
		link: Proptypes.shape({
			type: Proptypes.oneOf(["hash", "external", "internal"]),
			value: Proptypes.string,
		}),
		color: Proptypes.string,
		type: Proptypes.oneOf(["solid", "outline"]),
		text: Proptypes.string,
	}),
	cards: Proptypes.array,
};

ReviewsBanner.defaultProps = {
	header: "",
	description: "",
	cta: null,
	cards: [],
};

export default ReviewsBanner;
